import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "SupportSearch" })
export default class SupportSearch extends Vue {
    public localizer: any = Localizer;
    public searchtext: string = "";
    public suggestions: any[] = [];
    public minTextLength: number = 3;
    public suggestionIndex: number = -1;
    public isSuggestionNotFound: boolean = false;
    public isLoading: boolean = false;
    public debounceTimeOut: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("searchtext") onSearchtextChange(newText: string) {
        this.debounceGetSuggestions(newText, 500);
    }

    public debounceGetSuggestions(searchtext: any, delay: number) {
        let self = this;

        clearTimeout(this.debounceTimeOut);
        this.debounceTimeOut = setTimeout(async function (context) {
            if (searchtext != null && searchtext.length >= 3) {
                await self.getSuggestions(searchtext);
            } else if (searchtext === null || searchtext.length === 0) {
                self.clearSearch();
            }
        }, delay, this);
    }

    public checkMinTextLength(text: string): boolean {
        return text && text.length >= this.minTextLength;
    }

    public async getSuggestions(searchtext: string) {
        this.isLoading = true;
        this.suggestions = [];
        try {
            const response = (await Axios.post(this.routes.Support_GetSuggestions, { searchtext })).data;
            this.suggestions = response;
            this.isSuggestionNotFound = this.suggestions.length === 0;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.suggestions = [];
            }
        }
        this.isLoading = false;
    }

    public resetSuggestionValues() {
        this.suggestionIndex = -1;
        this.suggestions = [];
    }

    public suggestionMoveDown() {
        if (this.suggestions.length !== 0 && this.suggestionIndex < this.suggestions.length - 1) {
            this.suggestionIndex++;
        }
    }

    public suggestionMoveUp() {
        if (this.suggestions.length !== 0 && this.suggestionIndex > 0) {
            this.suggestionIndex--;
        }
    }

    public setSuggestion() {
        if (this.suggestionIndex !== -1) {
            const suggestion = this.suggestions[this.suggestionIndex];
            window.location.href = suggestion.linkUrl;
        }
    }

    public clearSearch() {
        this.searchtext = "";
        this.suggestions = [];
        this.isSuggestionNotFound = false;
    }

    public searchList() {
        if (this.searchtext?.length > 2) {
            window.location.href = `${this.routes.Support_SearchList}?searchtext=${this.searchtext}`;
        }
    }
};